import React, { useEffect, useState } from "react";
import { trackPromise } from "react-promise-tracker";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import suppliesApi from "../../../constants/suppliesApi";
import { AuthUserContext, withAuthentication } from "../../Auth/Session";
import CreateModal from "./CreateModal";
import _debounce from "lodash/debounce";

function Providers({ t }) {
  const [data, setData] = useState([]);
  const [modal, setModal] = useState(false);
  const [id, setId] = useState(null);

  useEffect(() => {
    getProviders();
  }, []);

  const getProviders = () => {
    trackPromise(
      suppliesApi
        .getProviders(localStorage.getItem("GlobalCustomerId"))
        .then((json) => {
          setData(json);
        })
        .catch((err) => {
          toast.error(err.response.data.detail);
        })
    );
  };

  const removeProvider = (id) => {
    if (window.confirm(t("providers.provider-item-0"))) {
      trackPromise(
        suppliesApi
          .removeProvidersById(localStorage.getItem("GlobalCustomerId"), id)
          .then((json) => {
            toast.success(t("providers.provider-item-1"));
            setData(data.filter((item) => item.id !== id));
          })
          .catch((err) => {
            toast.error(err.response.data.detail);
          })
      );
    }
  };

  const debounceFn = _debounce((searchTerm) => {
    if (searchTerm !== "") {
      let fil = data.filter((dt) => {
        return dt.name.toLowerCase().search(searchTerm) >= 0;
      });
      if (fil.length > 0) {
        setData(fil);
      } else {
        toast.info(`${t("providers.provider-item-2")} ${searchTerm}`);
      }
    } else {
      getProviders();
    }
  }, 1000);

  const handleSearch = (value) => {
    debounceFn(value.toLowerCase());
  };

  return (
    <AuthUserContext.Consumer>
      {(authUser) => (
        <div>
          <div className="container-fluid mt-100">
            <div className="row">
              <div className="col-md-8">
                <h3>{t("providers.provider-item-3")}</h3>
              </div>
              <div className="col-md-4">
                <input
                  className="form-control"
                  type="text"
                  id="search"
                  onChange={(e) => {
                    handleSearch(e.target.value);
                  }}
                  placeholder={t("globals.search-input")}
                />
              </div>
            </div>
            {!!authUser.permissions.create ? (
              <button
                className="btn btn-primary"
                onClick={() => {
                  setModal(true);
                  setId(null);
                }}
              >
                {t("globals.register")}
              </button>
            ) : null}
            <div className="text-center v-scroll mt-5">
              <table className="table table-striped table-bordered table-sm mb-0">
                <thead>
                  <tr>
                    <th scope="col">{t("providers.provider-item-4")}</th>
                    <th scope="col">ID/NIT</th>
                    <th scope="col">{t("providers.provider-item-5")}</th>
                    <th scope="col">{t("providers.provider-item-6")}</th>
                    <th scope="col">{t("providers.provider-item-7")}</th>
                  </tr>
                </thead>
                <tbody>
                  {data &&
                    data.map((data) => (
                      <tr>
                        <td>{data.name}</td>
                        <td>{data.identification}</td>
                        <td>{data.provider_type.name}</td>
                        <td>{data.services.name}</td>
                        <td>
                          <button
                            className="btn btn-primary"
                            onClick={() => {
                              setModal(true);
                              setId(data.id);
                            }}
                          >
                            {t("providers.provider-item-8")}
                          </button>
                          <button
                            className="btn btn-danger mx-2"
                            onClick={() => {
                              removeProvider(data.id);
                            }}
                          >
                            {t("providers.provider-item-9")}
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
          {modal && (
            <CreateModal
              open={modal}
              setData={setData}
              data={data}
              hide={() => {
                setModal(false);
              }}
              t={t}
              id={id}
            />
          )}
        </div>
      )}
    </AuthUserContext.Consumer>
  );
}

export default withAuthentication(Providers);
